<template>
    <div>
        <limitless-page-header title="Kortbeställningar">
            <template #header-elements>
                <limitless-page-header-button icon="icon-plus3" :route="{ name: 'customers.list', query: { createorder: 1 } }">Skapa ny order</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <order-list></order-list>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import OrderList from '@app/pages/cardorder/partials/OrderList.vue';

export default {
    name: 'CardOrderList',
    components: {
        OrderList,
        LimitlessPageHeaderButton,
        LimitlessPageHeader,
    },
    computed: {
        old_system_url() {
            return window.config.app.old_system_url;
        },
    },
};

</script>
